import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'serverValidation'
})
// export class ServerValidationPipe implements PipeTransform  {
//   transform(dict: Object, fieldName?: string): string[] {
//     let result: string[] = [];
//     for (let key in dict) {
//       if (dict.hasOwnProperty(key)) {
//         let index = <any>key;
//         if (!isNaN(index)) { // is numeric
//           result.push((<any>dict)[key]);
//         } else {
//           let keyTranslate = this.getKey(key);
//           for(let i = 0; i < dict[key].length; i++) {
//             let valueTranslate = this.getMessage(dict[key][i]);
//             result.push(keyTranslate + valueTranslate);
//           }
//         }
//       }
//     }
//     return result;
//   }
//
//   private getMessage(name) {
//     switch (name) {
//       case 'validation.required':
//         return ' является обязательным полем.';
//       case 'The email has already been taken.':
//         return ' - данный email уже занят.';
//       case 'validation.current_password':
//         return ' введен неверно.';
//       case 'The new password and password must be different.':
//         return ' совпадает со старым паролем.';
//       default:
//         return ' - некорректные данные.';
//     }
//   }
//
//   private getKey(name) {
//     switch (name) {
//       case 'first_name':
//         return 'Имя';
//       case 'last_name':
//         return 'Фамилия';
//       case 'patronymic':
//         return 'Отчество';
//       case 'phone':
//         return 'Телефон';
//       case 'email':
//         return 'Email';
//       case 'password':
//         return 'Пароль';
//       case 'new_password':
//         return 'Новый пароль';
//       default:
//         console.log(name);
//         return '';
//     }
//   }
//
// }

export class ServerValidationPipe implements PipeTransform  {
  transform(dict: Object, fieldName?: string): string[] {
    let result: string[] = [];
    for (let key in dict) {
      if (dict.hasOwnProperty(key)) {
        let index = <any>key;
        if (!isNaN(index)) { // is numeric
          result.push((<any>dict)[key]);
        } else {
          for(let i = 0; i < dict[key].length; i++) {
            result.push(dict[key][i]);
          }
        }
      }
    }
    return result;
  }
}



// WEBPACK FOOTER //
// ./src/app/pipes/server.side.validation.pipe.ts